import { ReactComponent as CursorPencilDark } from 'approot/shared/icons/icon_cursor_pencil_dark.svg';
import Icon, { IconProps } from './icon';

const IconCursorPencilDark = (props: IconProps & { id?: string }) => {
  return <Icon {...props} Svg={CursorPencilDark} />;
};

export default IconCursorPencilDark;
